// extracted by mini-css-extract-plugin
module.exports = {"topRibbon":"TopRibbon_topRibbon__3EtkG","topRibbon__container":"TopRibbon_topRibbon__container__s0ma-","comeFromTop":"TopRibbon_comeFromTop__1eHLs"};